module.exports = __webpack_public_path__ + "img/wallet.251895b4.svg";